module.exports = __webpack_public_path__ + "img/british american tobacco.ddfb9f01.png";